import { FileSyncOutlined, LoadingOutlined } from '@ant-design/icons'
import { handleUploadResponse } from '@components/_SiteWide/UploadStatus/utils/uploadStatus'
import { Dropdown, Menu, Tooltip } from 'antd'
import { useEffect, useRef, useState } from 'react'

import { UploadStatusModal } from './UploadStatusModal'

export function UploadDownloadButtons({
  fileName,
  refreshCallback,
  downloadEP,
  downloadEPData,
  uploadEP,
  normalizeFunction,
  excelOptions,
  asOfDate,
}) {
  const hiddenFileInput = useRef(null)
  const [isLoading, setIsLoading] = useState(false)
  const [uploadStatusModalVisible, setUploadStatusModalVisible] = useState(false)
  const [statusResponse, setStatusResponse] = useState()
  const [selectedMenuKey, setSelectedMenuKey] = useState()

  const handleClick = (input) => {
    input.current.click()
  }

  const handleExport = (optionClicked) => {
    setIsLoading(true)
    if (optionClicked.downloadEPData) downloadEPData = optionClicked.downloadEPData
    if (downloadEPData) {
      const url = window.URL.createObjectURL(new Blob([downloadEPData]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', optionClicked.fileName || fileName)
      document.body.appendChild(link)
      link.click()
      setIsLoading(false)
      setSelectedMenuKey(null)
      return
    }
    optionClicked
      .downloadEP(asOfDate)
      .then((resp) => {
        const url = window.URL.createObjectURL(new Blob([resp.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', optionClicked.fileName || fileName)
        document.body.appendChild(link)
        link.click()
        setIsLoading(false)
        setSelectedMenuKey(null)
      })
      .catch(() => {
        setIsLoading(false)
        setSelectedMenuKey(null)
      })
  }

  const handleUpload = (event) => {
    if (event.target.files.length !== 0) {
      setIsLoading(true)
      setUploadStatusModalVisible(true)
      const newFile = event.target.files[0]
      const formData = new FormData()
      formData.append('file', newFile)

      excelDropdownOptions[selectedMenuKey]
        .uploadEP(formData)
        .then((resp) => {
          if (resp) {
            handleUploadResponse(
              resp,
              setIsLoading,
              setStatusResponse,
              setUploadStatusModalVisible,
              normalizeFunction,
              hiddenFileInput
            )
            refreshCallback && refreshCallback()
            hiddenFileInput.current.value = ''
            setSelectedMenuKey(null)
          } else {
            throw Error
          }
        })
        .catch(() => {
          setIsLoading(false)
          setUploadStatusModalVisible(false)
          hiddenFileInput.current.value = ''
          setSelectedMenuKey(null)
        })
    }
  }

  const [excelDropdownOptions, setExcelDropdownOptions] = useState([])
  useEffect(() => {
    const defaultOptions = [
      {
        title: 'Download To Excel',
        downloadEP,
        filename: fileName,
        onClick: () => {
          handleExport({ downloadEP, fileName })
        },
      },
    ]
    if (uploadEP) {
      defaultOptions.push({
        title: 'Upload From Excel',
        uploadEP,
      })
    }

    const options = excelOptions || defaultOptions

    setExcelDropdownOptions(
      options.filter((o) => {
        if (Object.hasOwn(o, 'downloadEP') && typeof o.downloadEP !== 'function') return false
        if (Object.hasOwn(o, 'uploadEP') && typeof o.uploadEP !== 'function') return false
        return true
      })
    )
  }, [excelOptions])

  const handleOptionClick = (option) => {
    if (option.uploadEP) handleClick(hiddenFileInput)
    else if (option.downloadEP) handleExport(option)
    else if (option.onClick) option.onClick()
  }

  const handleMenuClick = (e) => {
    setSelectedMenuKey(e.key)
    const optionClicked = excelDropdownOptions[e.key]
    handleOptionClick(optionClicked)
  }
  const menu = (
    <Menu onClick={handleMenuClick}>
      {excelDropdownOptions &&
        excelDropdownOptions.map((option, index) => <Menu.Item key={index}>{option.title}</Menu.Item>)}
    </Menu>
  )

  return (
    <>
      <Tooltip title='Work in Excel'>
        <Dropdown.Button
          style={{ width: 'auto' }}
          overlay={menu}
          onClick={() => handleOptionClick(excelDropdownOptions[0])}
          disabled={isLoading}
        >
          {isLoading ? (
            <LoadingOutlined style={{ fontSize: '1.2em' }} />
          ) : (
            <FileSyncOutlined style={{ fontSize: '1.2em' }} />
          )}
        </Dropdown.Button>
      </Tooltip>
      <input
        type='file'
        onChange={(event) =>
          handleUpload(event, setIsLoading, refreshCallback, setStatusResponse, setUploadStatusModalVisible)
        }
        ref={hiddenFileInput}
        style={{ display: 'none' }}
      />
      <UploadStatusModal
        uploadStatusModalVisible={uploadStatusModalVisible}
        setUploadStatusModalVisible={setUploadStatusModalVisible}
        statusResponse={statusResponse}
        isUploading={isLoading}
      />
    </>
  )
}
